import React from 'react';
import { ministryInfo } from '../mock';
import { Heart, ArrowRight } from 'lucide-react';

export const Hero = () => {
  const scrollToServices = () => {
    const element = document.querySelector('#services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="section-padding" style={{ 
      background: 'linear-gradient(135deg, rgba(139, 69, 19, 0.1) 0%, rgba(205, 133, 63, 0.1) 100%)',
      position: 'relative'
    }}>
      {/* Background image overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: 'url(https://images.unsplash.com/photo-1506905925346-21bda4d32df4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxtb3VudGFpbnMlMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzU2MjYzNzAwfDA&ixlib=rb-4.1.0&q=85)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        opacity: 0.15,
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="grid-two-column">
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
              <Heart size={24} style={{ color: '#CD853F' }} />
              <span className="body-regular" style={{ color: '#8B4513', fontWeight: '600' }}>
                {ministryInfo.tagline}
              </span>
            </div>
            
            <h1 className="hero-large" style={{ marginBottom: '32px', color: '#2F1B14' }}>
              We exist to repair the breach where lies and brokenness have taken root, and restore lives on the foundation of Truth
            </h1>
            
            <p className="body-large" style={{ marginBottom: '48px', color: '#5D4037', lineHeight: '1.6' }}>
              Whether you are in a season of healing, growth, or searching for peace, you are not alone. 
              We're here to walk with you as you rebuild your life on a firm foundation—Jesus Christ.
            </p>
            
            <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
              <button 
                className="btn-primary" 
                onClick={scrollToServices}
                style={{ 
                  background: '#8B4513',
                  borderColor: '#8B4513',
                  color: 'white'
                }}
              >
                Explore Our Services
              </button>
              
              <button 
                className="btn-secondary" 
                onClick={scrollToContact}
                style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  gap: '8px',
                  color: '#8B4513',
                  borderColor: '#8B4513'
                }}
              >
                Get in Touch
                <ArrowRight size={16} />
              </button>
            </div>
          </div>
          
          {/* Right Column - Standing in the Gap Text Only */}
          <div style={{
            background: 'rgba(255, 248, 220, 0.9)',
            borderRadius: '0px',
            padding: '48px',
            textAlign: 'center'
          }}>
            <h3 className="heading-2" style={{ marginBottom: '16px', color: '#8B4513' }}>
              Standing in the Gap
            </h3>
            
            <p className="body-regular" style={{ color: '#5D4037' }}>
              We stand in the gap, bringing healing, restoration, and God's truth where things have been broken.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};